import { RestSlice } from '../../../../redux/rest.slice';
import { Event } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const fogEventsSlice = new RestSlice<Event>(
	localizationService.getLocalizedString('events.events'),
	Resource.Events
);
export const fogEventsReducer = fogEventsSlice.rests.reducer;
